import { ORGANIZATION_GOVERNANCE_OPERATION_IDS } from '../../operations/organization-governance.operations.js';
import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_REFRESH, AUTH_PASSWORD_CHANGE, AUTH_SESSION_MANAGE, AUTH_SESSION_REVOKE, AUTH_ENROLL_MFA, AUTH_VERIFY_MFA, AUTH_DISABLE_MFA, AUTH_REGENERATE_BACKUP_CODES, AUTH_READ_PROFILE, AUTH_SWITCH_CONTEXT, DASHBOARD_VIEW, HOLDINGS_VIEW, REPORTS_VIEW, REPORT_DETAIL_READ, ADMIN_HUB, ADMIN_HUB_ORGANIZATION, DATA_HUB, NAVIGATION_SHELL_READ, NAVIGATION_ROUTES_READ, NAVIGATION_ROUTE_READ, NAVIGATION_HUB_READ, SETTINGS_VIEW, SETTINGS_PROFILE, SETTINGS_PROFILE_UPDATE, SETTINGS_PREFERENCES, SETTINGS_PREFERENCES_UPDATE, SETTINGS_MFA, SETTINGS_SECURITY, ORGANIZATION_PROFILE_READ, ORGANIZATION_PROFILE_DETAIL_READ, ORGANIZATION_PROFILE_UPDATE, ORGANIZATION_BRANCHES_LIST, ORGANIZATION_BRANCHES_READ, ORGANIZATION_BRANCHES_CREATE, ORGANIZATION_BRANCHES_UPDATE, ORGANIZATION_BRANCHES_DISABLE, ORGANIZATION_BRANCHES_MAKE_DEFAULT, ORGANIZATION_MODULES_LIST_ASSIGNED, ORGANIZATION_MODULES_ENABLE, ORGANIZATION_MODULES_DISABLE, ORGANIZATION_MODULES_CONFIGURE, ORGANIZATION_USERS_LIST, ORGANIZATION_USERS_READ, ORGANIZATION_USERS_CREATE, ORGANIZATION_USERS_UPDATE, ORGANIZATION_USERS_DISABLE, ORGANIZATION_USERS_UNLOCK, ORGANIZATION_USERS_FORCE_PASSWORD_RESET, ORGANIZATION_USERS_MFA_REQUIRE_ENROLLMENT, ORGANIZATION_USERS_MFA_RESET_ENROLLMENT, ORGANIZATION_USERS_MFA_DISABLE, ORGANIZATION_USERS_MFA_REGENERATE_RECOVERY, ORGANIZATION_ROLES_LIST, ORGANIZATION_ROLES_READ, ORGANIZATION_ROLES_CREATE, ORGANIZATION_ROLES_UPDATE, ORGANIZATION_ROLES_DISABLE, ORGANIZATION_ACCESS_INSPECTOR, ORGANIZATION_PERMISSIONS_LIST, ORGANIZATION_PERMISSION_ASSIGNMENTS_LIST, ORGANIZATION_PERMISSION_ASSIGNMENTS_EDIT, ORGANIZATION_CLIENTS_LIST, ORGANIZATION_CLIENTS_READ, ORGANIZATION_CLIENTS_CREATE, ORGANIZATION_CLIENTS_UPDATE, ORGANIZATION_CLIENTS_DISABLE, ORGANIZATION_CLIENT_ACCOUNTS_LIST, ORGANIZATION_CLIENT_ACCOUNTS_READ, ORGANIZATION_CLIENT_ACCOUNTS_CREATE, ORGANIZATION_CLIENT_ACCOUNTS_UPDATE, ORGANIZATION_CLIENT_ACCOUNTS_DISABLE, ORGANIZATION_CLIENT_ACCOUNT_DOCUMENTS_LIST, ORGANIZATION_CLIENT_ACCOUNT_DOCUMENTS_CREATE, ORGANIZATION_CLIENT_ACCOUNT_DOCUMENTS_REMOVE, ORGANIZATION_CLIENT_ACCOUNT_SIGNATORIES_LIST, ORGANIZATION_CLIENT_ACCOUNT_SIGNATORIES_CREATE, ORGANIZATION_CLIENT_ACCOUNT_SIGNATORIES_REMOVE, ORGANIZATION_PORTFOLIOS_LIST, ORGANIZATION_PORTFOLIOS_READ, ORGANIZATION_PORTFOLIOS_CREATE, ORGANIZATION_PORTFOLIOS_UPDATE, ORGANIZATION_PORTFOLIOS_DISABLE, ORGANIZATION_BENCHMARK_ASSIGNMENTS_LIST, ORGANIZATION_BENCHMARK_ASSIGNMENTS_CREATE, ORGANIZATION_BENCHMARK_ASSIGNMENTS_APPROVE, ORGANIZATION_AUDIT_LIST, ORGANIZATION_AUDIT_READ, ORGANIZATION_AUDIT_EXPORT, TRANSACTION_LIST, TRANSACTION_EXPORT, TRANSACTION_GET, TRANSACTION_CREATE, TRANSACTION_SUBMIT, TRANSACTION_APPROVE, TRANSACTION_REJECT, TRANSACTION_WITHDRAW, TRANSACTION_POST, TRANSACTION_REPAIR, TRANSACTION_REPOST, TRANSACTION_REVERSE, TRANSACTION_LOTS, TRANSACTION_DISPOSALS, INSTRUMENT_LIST, INSTRUMENT_GET, INSTRUMENT_CREATE, INSTRUMENT_UPDATE, INSTRUMENT_OVERRIDE_CREATE, INSTRUMENT_OVERRIDE_LIST, FACT_BATCHES_LIST, FACT_BATCH_GET, FACT_CREATE, PORTFOLIO_ACCOUNT_LIST, PORTFOLIO_ACCOUNT_GET, PORTFOLIO_ACCOUNT_GET_BALANCE, PORTFOLIO_ACCOUNT_CREATE, PORTFOLIO_ACCOUNT_UPDATE, PORTFOLIO_ACCOUNT_SIGNATORIES_LIST, PORTFOLIO_ACCOUNT_SIGNATORY_CREATE, PORTFOLIO_ACCOUNT_SIGNATORY_DELETE, CLIENT_ACCOUNT_LIST, CLIENT_ACCOUNT_GET, CLIENT_ACCOUNT_DOCUMENTS_LIST, CLIENT_ACCOUNT_CREATE, CLIENT_ACCOUNT_UPDATE, CLIENT_ACCOUNT_DOCUMENT_CREATE, CORPORATE_ACTION_LIST, CORPORATE_ACTION_GET, CORPORATE_ACTION_CREATE, CORPORATE_ACTION_PROCESS, CORPORATE_ACTION_ENTITLEMENTS_LIST, CORPORATE_ACTION_ELECT, CORPORATE_ACTION_ALLOCATE, CORPORATE_ACTION_UPDATE, RECONCILIATION_LIST, RECONCILIATION_GET, RECONCILIATION_CREATE, RECONCILIATION_UPDATE, RECONCILIATION_STATEMENT_CREATE, RECONCILIATION_STATEMENT_LIST, RECONCILIATION_STATEMENT_GET, RECONCILIATION_RUN_CREATE, RECONCILIATION_RUN_LIST, RECONCILIATION_RUN_GET, RECONCILIATION_RUN_BREAKS_LIST, RECONCILIATION_RUN_MATCHES_LIST, RECONCILIATION_BREAK_GET, RECONCILIATION_BREAK_UPDATE, RECONCILIATION_ADJUSTMENT_CREATE, RECONCILIATION_ADJUSTMENT_LIST, RECONCILIATION_ADJUSTMENT_APPROVE, RECONCILIATION_ADJUSTMENT_REJECT, RECONCILIATION_ADJUSTMENT_POST, RECONCILIATION_AGING_EXECUTE, RECONCILIATION_ESCALATION_EXECUTE, IMPORT_LIST, IMPORT_GET, IMPORT_ROWS_LIST, IMPORT_UPLOAD, IMPORT_COMMIT, IMPORT_VALIDATE, IMPORT_RECOVER, IMPORT_CANCEL, IMPORT_RECONCILE, ACCOUNTING_OPENING_CUTOVER_PREVIEW, ACCOUNTING_OPENING_CUTOVER_APPROVE, ACCOUNTING_OPENING_CUTOVER_GET, ACCOUNTING_FISCAL_YEAR_LIST, ACCOUNTING_FISCAL_YEAR_GET, ACCOUNTING_FISCAL_YEAR_CREATE, ACCOUNTING_FISCAL_YEAR_CLOSE, ACCOUNTING_FISCAL_YEAR_REOPEN, ACCOUNTING_FISCAL_PERIODS_GENERATE, ACCOUNTING_FISCAL_PERIOD_CREATE, ACCOUNTING_FISCAL_PERIOD_LIST, ACCOUNTING_FISCAL_PERIOD_LOCK, ACCOUNTING_FISCAL_PERIOD_UNLOCK, TAX_RULE_LIST, TAX_RULE_READ, TAX_RULE_CREATE_VERSION, TAX_RULE_SUBMIT, TAX_RULE_APPROVE, TAX_RULE_SUSPEND, TAX_RULE_RETIRE, TAX_RULE_IMPACT_ANALYZE, COMPLIANCE_BREACHES_OPEN, COMPLIANCE_BREACHES_REMEDIATE, COMPLIANCE_BREACHES_WAIVE, ACCOUNTING_JOURNAL_TEMPLATE_VIEW, ACCOUNTING_JOURNAL_TEMPLATE_CREATE, ACCOUNTING_JOURNAL_TEMPLATE_APPROVE, ACCOUNTING_JOURNAL_SCHEDULE_VIEW, ACCOUNTING_JOURNAL_SCHEDULE_CREATE, ACCOUNTING_JOURNAL_SCHEDULE_AMEND, ACCOUNTING_JOURNAL_SCHEDULE_CANCEL, ACCOUNTING_JOURNAL_SCHEDULE_APPROVE, } from '../../operations/operation-ids.js';
/**
 * Organization Admin V1: full organization-scoped portfolio operations only.
 * Deferred module operations remain registered globally but are not granted.
 *
 * First-release authority keeps predefined roles readable for assignment and
 * also grants custom-role mutation and the access inspector.
 */
export const ORGANIZATION_ADMIN_OPERATIONS = [
    ...ORGANIZATION_GOVERNANCE_OPERATION_IDS,
    AUTH_LOGIN,
    AUTH_LOGOUT,
    AUTH_REFRESH,
    AUTH_PASSWORD_CHANGE,
    AUTH_SESSION_MANAGE,
    AUTH_SESSION_REVOKE,
    AUTH_ENROLL_MFA,
    AUTH_VERIFY_MFA,
    AUTH_DISABLE_MFA,
    AUTH_REGENERATE_BACKUP_CODES,
    AUTH_READ_PROFILE,
    AUTH_SWITCH_CONTEXT,
    DASHBOARD_VIEW,
    HOLDINGS_VIEW,
    REPORTS_VIEW,
    REPORT_DETAIL_READ,
    ADMIN_HUB,
    ADMIN_HUB_ORGANIZATION,
    DATA_HUB,
    NAVIGATION_SHELL_READ,
    NAVIGATION_ROUTES_READ,
    NAVIGATION_ROUTE_READ,
    NAVIGATION_HUB_READ,
    SETTINGS_VIEW,
    SETTINGS_PROFILE,
    SETTINGS_PROFILE_UPDATE,
    SETTINGS_PREFERENCES,
    SETTINGS_PREFERENCES_UPDATE,
    SETTINGS_MFA,
    SETTINGS_SECURITY,
    ORGANIZATION_PROFILE_READ,
    ORGANIZATION_PROFILE_DETAIL_READ,
    ORGANIZATION_PROFILE_UPDATE,
    ORGANIZATION_BRANCHES_LIST,
    ORGANIZATION_BRANCHES_READ,
    ORGANIZATION_BRANCHES_CREATE,
    ORGANIZATION_BRANCHES_UPDATE,
    ORGANIZATION_BRANCHES_DISABLE,
    ORGANIZATION_BRANCHES_MAKE_DEFAULT,
    ORGANIZATION_MODULES_LIST_ASSIGNED,
    ORGANIZATION_MODULES_ENABLE,
    ORGANIZATION_MODULES_DISABLE,
    ORGANIZATION_MODULES_CONFIGURE,
    ORGANIZATION_USERS_LIST,
    ORGANIZATION_USERS_READ,
    ORGANIZATION_USERS_CREATE,
    ORGANIZATION_USERS_UPDATE,
    ORGANIZATION_USERS_DISABLE,
    ORGANIZATION_USERS_UNLOCK,
    ORGANIZATION_USERS_FORCE_PASSWORD_RESET,
    ORGANIZATION_USERS_MFA_REQUIRE_ENROLLMENT,
    ORGANIZATION_USERS_MFA_RESET_ENROLLMENT,
    ORGANIZATION_USERS_MFA_DISABLE,
    ORGANIZATION_USERS_MFA_REGENERATE_RECOVERY,
    ORGANIZATION_ROLES_LIST,
    ORGANIZATION_ROLES_READ,
    ORGANIZATION_ROLES_CREATE,
    ORGANIZATION_ROLES_UPDATE,
    ORGANIZATION_ROLES_DISABLE,
    ORGANIZATION_ACCESS_INSPECTOR,
    ORGANIZATION_PERMISSIONS_LIST,
    ORGANIZATION_PERMISSION_ASSIGNMENTS_LIST,
    ORGANIZATION_PERMISSION_ASSIGNMENTS_EDIT,
    ORGANIZATION_CLIENTS_LIST,
    ORGANIZATION_CLIENTS_READ,
    ORGANIZATION_CLIENTS_CREATE,
    ORGANIZATION_CLIENTS_UPDATE,
    ORGANIZATION_CLIENTS_DISABLE,
    ORGANIZATION_CLIENT_ACCOUNTS_LIST,
    ORGANIZATION_CLIENT_ACCOUNTS_READ,
    ORGANIZATION_CLIENT_ACCOUNTS_CREATE,
    ORGANIZATION_CLIENT_ACCOUNTS_UPDATE,
    ORGANIZATION_CLIENT_ACCOUNTS_DISABLE,
    ORGANIZATION_CLIENT_ACCOUNT_DOCUMENTS_LIST,
    ORGANIZATION_CLIENT_ACCOUNT_DOCUMENTS_CREATE,
    ORGANIZATION_CLIENT_ACCOUNT_DOCUMENTS_REMOVE,
    ORGANIZATION_CLIENT_ACCOUNT_SIGNATORIES_LIST,
    ORGANIZATION_CLIENT_ACCOUNT_SIGNATORIES_CREATE,
    ORGANIZATION_CLIENT_ACCOUNT_SIGNATORIES_REMOVE,
    ORGANIZATION_PORTFOLIOS_LIST,
    ORGANIZATION_PORTFOLIOS_READ,
    ORGANIZATION_PORTFOLIOS_CREATE,
    ORGANIZATION_PORTFOLIOS_UPDATE,
    ORGANIZATION_PORTFOLIOS_DISABLE,
    ORGANIZATION_BENCHMARK_ASSIGNMENTS_LIST,
    ORGANIZATION_BENCHMARK_ASSIGNMENTS_CREATE,
    ORGANIZATION_BENCHMARK_ASSIGNMENTS_APPROVE,
    ORGANIZATION_AUDIT_LIST,
    ORGANIZATION_AUDIT_READ,
    ORGANIZATION_AUDIT_EXPORT,
    TRANSACTION_LIST,
    TRANSACTION_EXPORT,
    TRANSACTION_GET,
    TRANSACTION_CREATE,
    TRANSACTION_SUBMIT,
    TRANSACTION_APPROVE,
    TRANSACTION_REJECT,
    TRANSACTION_WITHDRAW,
    TRANSACTION_POST,
    TRANSACTION_REPAIR,
    TRANSACTION_REPOST,
    TRANSACTION_REVERSE,
    TRANSACTION_LOTS,
    TRANSACTION_DISPOSALS,
    INSTRUMENT_LIST,
    INSTRUMENT_GET,
    INSTRUMENT_CREATE,
    INSTRUMENT_UPDATE,
    INSTRUMENT_OVERRIDE_CREATE,
    INSTRUMENT_OVERRIDE_LIST,
    FACT_BATCHES_LIST,
    FACT_BATCH_GET,
    FACT_CREATE,
    PORTFOLIO_ACCOUNT_LIST,
    PORTFOLIO_ACCOUNT_GET,
    PORTFOLIO_ACCOUNT_GET_BALANCE,
    PORTFOLIO_ACCOUNT_CREATE,
    PORTFOLIO_ACCOUNT_UPDATE,
    PORTFOLIO_ACCOUNT_SIGNATORIES_LIST,
    PORTFOLIO_ACCOUNT_SIGNATORY_CREATE,
    PORTFOLIO_ACCOUNT_SIGNATORY_DELETE,
    CLIENT_ACCOUNT_LIST,
    CLIENT_ACCOUNT_GET,
    CLIENT_ACCOUNT_DOCUMENTS_LIST,
    CLIENT_ACCOUNT_CREATE,
    CLIENT_ACCOUNT_UPDATE,
    CLIENT_ACCOUNT_DOCUMENT_CREATE,
    CORPORATE_ACTION_LIST,
    CORPORATE_ACTION_GET,
    CORPORATE_ACTION_CREATE,
    CORPORATE_ACTION_PROCESS,
    CORPORATE_ACTION_ENTITLEMENTS_LIST,
    CORPORATE_ACTION_ELECT,
    CORPORATE_ACTION_ALLOCATE,
    CORPORATE_ACTION_UPDATE,
    RECONCILIATION_LIST,
    RECONCILIATION_GET,
    RECONCILIATION_CREATE,
    RECONCILIATION_UPDATE,
    RECONCILIATION_STATEMENT_CREATE,
    RECONCILIATION_STATEMENT_LIST,
    RECONCILIATION_STATEMENT_GET,
    RECONCILIATION_RUN_CREATE,
    RECONCILIATION_RUN_LIST,
    RECONCILIATION_RUN_GET,
    RECONCILIATION_RUN_BREAKS_LIST,
    RECONCILIATION_RUN_MATCHES_LIST,
    RECONCILIATION_BREAK_GET,
    RECONCILIATION_BREAK_UPDATE,
    RECONCILIATION_ADJUSTMENT_CREATE,
    RECONCILIATION_ADJUSTMENT_LIST,
    RECONCILIATION_ADJUSTMENT_APPROVE,
    RECONCILIATION_ADJUSTMENT_REJECT,
    RECONCILIATION_ADJUSTMENT_POST,
    RECONCILIATION_AGING_EXECUTE,
    RECONCILIATION_ESCALATION_EXECUTE,
    IMPORT_LIST,
    IMPORT_GET,
    IMPORT_ROWS_LIST,
    IMPORT_UPLOAD,
    IMPORT_COMMIT,
    IMPORT_VALIDATE,
    IMPORT_RECOVER,
    IMPORT_CANCEL,
    IMPORT_RECONCILE,
    ACCOUNTING_OPENING_CUTOVER_PREVIEW,
    ACCOUNTING_OPENING_CUTOVER_APPROVE,
    ACCOUNTING_OPENING_CUTOVER_GET,
    ACCOUNTING_FISCAL_YEAR_LIST,
    ACCOUNTING_FISCAL_YEAR_GET,
    ACCOUNTING_FISCAL_YEAR_CREATE,
    ACCOUNTING_FISCAL_YEAR_CLOSE,
    ACCOUNTING_FISCAL_YEAR_REOPEN,
    ACCOUNTING_FISCAL_PERIODS_GENERATE,
    ACCOUNTING_FISCAL_PERIOD_CREATE,
    ACCOUNTING_FISCAL_PERIOD_LIST,
    ACCOUNTING_FISCAL_PERIOD_LOCK,
    ACCOUNTING_FISCAL_PERIOD_UNLOCK,
    TAX_RULE_LIST,
    TAX_RULE_READ,
    TAX_RULE_CREATE_VERSION,
    TAX_RULE_SUBMIT,
    TAX_RULE_APPROVE,
    TAX_RULE_SUSPEND,
    TAX_RULE_RETIRE,
    TAX_RULE_IMPACT_ANALYZE,
    COMPLIANCE_BREACHES_OPEN,
    COMPLIANCE_BREACHES_REMEDIATE,
    COMPLIANCE_BREACHES_WAIVE,
    ACCOUNTING_JOURNAL_TEMPLATE_VIEW,
    ACCOUNTING_JOURNAL_TEMPLATE_CREATE,
    ACCOUNTING_JOURNAL_TEMPLATE_APPROVE,
    ACCOUNTING_JOURNAL_SCHEDULE_VIEW,
    ACCOUNTING_JOURNAL_SCHEDULE_CREATE,
    ACCOUNTING_JOURNAL_SCHEDULE_AMEND,
    ACCOUNTING_JOURNAL_SCHEDULE_CANCEL,
    ACCOUNTING_JOURNAL_SCHEDULE_APPROVE,
    'investment.clients.list',
    'investment.clients.get',
    'investment.portfolios.list',
    'investment.portfolios.get',
    'investment.positions.list',
    'investment.cash.list',
    'settlement.instructions.list',
    'settlement.failures.list',
    'settlement.instructions.get',
    'settlement.instructions.availability',
    'settlement.instructions.create',
    'settlement.instructions.confirm',
    'settlement.instructions.correct',
    'settlement.instructions.cancel',
    'investment.position-transfer.list',
    'investment.position-transfer.get',
    'investment.position-transfer.eligibility',
    'investment.position-transfer.request-eligibility',
    'investment.position-transfer.request',
    'investment.position-transfer.approve',
    'investment.position-transfer.execute',
    'investment.position-transfer.cancel',
    'investment.position-transfer.reverse',
];
